import {Websocket} from "./websocket.js";
import {handleFetchError, isChatOpen} from "./helpers/functions.js";
import {ServerApi} from "./api.js";
import { Messages } from "./messages/messages.js";
import { OneDialog } from "./messages/one-dialog.js";


$('html')
    .on('click', '#chat-toggle-button,.chat-dialog .close-btn', async function(){
        $('.chat-dialog').toggleClass('invisible');
        const open = isChatOpen(true);
        Websocket.Instance.subscribeForChatMessages(open);
        if(open) {
            await loadMessages(); //.catch(handleFetchError);
            // Websocket.Instance.readMessages(0);
        }
        else{
            $('.chat-dialog .fullscreen').removeClass('fa-compress').addClass('fa-expand');
            $('body').removeClass('chat-fullscreen');
        }
    })
    .on('click', '.chat-dialog .fullscreen', async function(){
        $(this).toggleClass('fa-expand').toggleClass('fa-compress');
        $('body').toggleClass('chat-fullscreen');
    })
async function loadMessages(){
    const dialog = Messages.Instance?.dialogs.find(e=>e.data.user_id == 0);
    if(!dialog) return;
    dialog.clearMessages();
    try {

        const messages = await ServerApi.messages.getMessages(0, 0);
        for(let i of messages)
            dialog.addMessage(i);

    }
    catch (e){
        handleFetchError(e);
    }
}
function isChatPage(){
    return  $('#chat-page')[0];
}
function isMessagesPage(){
    return $('.dialogs-container')[0];
}
Websocket.Instance.onreopen(async ()=>{
    if(isChatOpen() || isChatPage()) {
        Websocket.Instance.subscribeForChatMessages(true);
        await loadMessages();
    }
})
// Websocket.Instance.on<NewMessageEvent>('new-message', (msg)=>{
//     if(msg.message.to_id != 0) return;
//     // if chat is open
//     if(isChatOpen()){
//         if(!document.fullscreenElement)
//             Websocket.Instance.readMessages(0);
//         else
//             $(document).one(
//                 'fullscreenchange',
//                 ()=>Websocket.Instance.readMessages(0)
//             );
//     }
// })
$(()=>{
    const dialog = new OneDialog(
        $('notexists'),
        {user_id: 0, roles: [], nickname: '', last_message: '', avatars: {big: '', small: '', full: ''}, unread_count: 0, banned: false, last_online: 0, date: 0},
        $('.messages-with-user')
            .eq(0)
            .on('scroll', async function(){
                const scroll: number = $(this).scrollTop()??999;
                if(scroll < 200 && (isChatOpen() || isChatPage()))
                    await Messages.Instance?.loadMoreMessages(dialog);
            })
    );
    Messages.Instance?.dialogs?.push(dialog);
    if(isChatPage() || isMessagesPage()){
        $('.content-block .search-block-wrapper,.mobile-filter,.sidebar,footer').css('display', 'none');
    }
    if(isChatPage()) {
        $("#chatter").css('display', 'none')
        Messages.Instance?.loadMoreMessages(dialog);
    }
});
